module.exports = __webpack_public_path__ + "img/whats-new-19_en.8e520f5.jpg";